import React, { Component } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";

class Letter1 extends Component {
  state = {};

  render() {
    if (this.props.extraProp1) {
      return (
        <page size="A4" style={{ fontFamily: "Arial, sans-serif" }}>
          <div
            className="d-flex justify-content-end mt-3 mr-5"
            style={{ marginBottom: 60 }}
          >
            <img
              src={require("../../Assets/images/print-logo.png").default || require("../../Assets/images/print-logo.png")}
              alt="logo"
              className="logoImage"
            />
          </div>
          <div style={{ marginTop: 0, marginBottom: 100, fontSize: 20 }}>
            <br />
            <br />
            <div>To The Occupier</div>
            {this.props.address?.split(",").map((add, idx) => (
              <div key={idx}>{add}</div>
            ))}
          </div>

          <div>
            <span style={{ fontWeight: "bold" }}>
              You've moved! Has your address moved with you?
            </span>{" "}
            <span style={{ fontWeight: "bold" }}>
              First off—welcome to your new home!
            </span>
            <div style={{ margin: "16px 0" }}>
              Whether you're still unpacking or already enjoying your new space,
              there's always a long to-do list when moving house.
            </div>
            <div style={{ margin: "16px 0" }}>
              One job that's easy to forget—but really important—is updating
              your address with all your service providers. Banks, pensions,
              dentists, HMRC, opticians, vets, loyalty cards… the list goes on.
            </div>
            <div style={{ margin: "16px 0" }}>
              That's where <span style={{ fontWeight: "bold" }}>Moveinout</span>{" "}
              comes in.
            </div>
            <div style={{ margin: "16px 0" }}>
              We're a simple, secure online address notification service that
              notifies all your service providers of your new address—all from a
              single platform. No hold music, and no risk of important post
              going astray. Just one simple, straightforward process that saves
              you time, hassle, and stress.
            </div>
            <div
              style={{
                margin: "24px 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: "100%",
              }}
            >
              <div>
                <div style={{ fontWeight: "bold", marginBottom: 4 }}>
                  Avoiding the risk of identity fraud
                </div>
                <div style={{ fontWeight: "bold", marginBottom: 4 }}>
                  No Royal Mail Redirection renewal fees
                </div>
                <div style={{ fontWeight: "bold", marginBottom: 4 }}>
                  Saving hours notifying your address change
                </div>
              </div>
              <img
                src={require("../../Assets/images/coupon.png").default || require("../../Assets/images/coupon.png")}
                alt="Coupon"
                style={{ marginRight: 20 }}
              />
            </div>
            <div style={{ margin: "24px 0" }}>
              Join thousands of people across the UK who are already using
              Moveinout to handle their change of address admin quickly and
              easily. You can get started by visiting{" "}
              <span style={{ fontWeight: "bold" }}>www.moveinout.co.uk</span>{" "}
              and update your address in minutes!
            </div>
            <img
              src={require("../../Assets/images/iconsPdfBottom.png").default || require("../../Assets/images/iconsPdfBottom.png")}
              alt="images pdf bottom"
              width="100%"
              style={{ marginLeft: "-10px" }}
            />
            <div style={{ fontSize: 13, marginTop: 16 }}>
              Moveinout is registered and incorporated in England & Wales -
              Company number: 11585502 - ICO registration number: ZA788144
            </div>
          </div>
        </page>
      );
    }

    return (
      <page size="A4">
        <div className="letter-content py-5">
          {this.props.address?.split(",").map((add, i) => (
            <p key={i}>{add}</p>
          ))}
        </div>
      </page>
    );
  }
}

class AddressLetter extends Component {
  state = {};
  render() {
    return (
      <div>
        <ReactToPrint
          trigger={() => this.props.button}
          content={() => this.componentRef}
          onBeforePrint={() => (document.title = `${this.props.name}`)}
          onAfterPrint={() => {
            document.title =
              "Moveinout Dashboard | Change of address notifications";
          }}
        />
        <div style={{ display: "none" }}>
          <Letter1
            address={this.props.address}
            extraProp1={this.props.extraProp1}
            extraProp2={this.props.extraProp2}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(AddressLetter);
